import Tag from './Tag'

export type { TagProps } from './Tag.types'

export default Tag
